/**
 * Maps a care-line tag string to rounded-badge colors and display copy (continuation vs new line).
 * Matching is case-insensitive so API casing drift still yields the green / amber themes.
 *
 * @param regimenTag - Tag from {@link resolveRegimenCareTagForHeader} or legacy flowsheet callers
 * @returns Badge label, colors, and border for {@link BadgeWithIconRounded}
 */
export const getBadgeDetailsAndIconColorForCareTag = (
  regimenTag: string,
): {
  badgeText: string;
  iconColor: string;
  badgeBgColor: string;
  badgeTextColor: string;
  borderColor: string;
} => {
  const trimmed = regimenTag.trim();
  const key = trimmed.toLowerCase();

  if (key === "continuation of care") {
    return {
      badgeText: "Continuation of care",
      iconColor: "#008367",
      badgeBgColor: "#E6F3F0",
      badgeTextColor: "#1F1F1F",
      borderColor: "#008367",
    };
  }

  if (key === "initial line" || key === "initial line of care") {
    return {
      badgeText: "New line of care",
      iconColor: "#C24400",
      badgeBgColor: "#FFF3E0",
      badgeTextColor: "#1F1F1F",
      borderColor: "#C24400",
    };
  }

  return {
    badgeText: trimmed,
    iconColor: "#000000",
    badgeBgColor: "#F5F5F5",
    badgeTextColor: "#000000",
    borderColor: "#000000",
  };
};
